var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5625 2.0625L12.5625 20.5938L19.375 14.9219C19.533 14.7906 19.7153 14.6916 19.9115 14.6308C20.1078 14.5699 20.3141 14.5483 20.5186 14.5672C20.9318 14.6052 21.3129 14.8059 21.5781 15.125C21.8433 15.4441 21.9709 15.8555 21.9328 16.2686C21.8948 16.6818 21.6941 17.0629 21.375 17.3281L12 25.1406C11.9254 25.1932 11.8471 25.2402 11.7656 25.2812C11.6875 25.2813 11.6406 25.3594 11.5625 25.3906C11.3833 25.4614 11.1926 25.4985 11 25.5C10.8074 25.4985 10.6167 25.4614 10.4375 25.3906C10.3594 25.3906 10.3125 25.3125 10.2344 25.2812C10.1529 25.2402 10.0746 25.1932 10 25.1406L0.624999 17.3281C0.44862 17.1812 0.306776 16.9972 0.209556 16.7893C0.112335 16.5814 0.0621264 16.3545 0.0624992 16.125C0.0617859 15.7599 0.188935 15.4061 0.421874 15.125C0.553045 14.9668 0.714139 14.836 0.895932 14.7401C1.07772 14.6443 1.27664 14.5852 1.48129 14.5663C1.68595 14.5475 1.89231 14.5692 2.08856 14.6302C2.28482 14.6912 2.46711 14.7903 2.625 14.9219L9.4375 20.5938L9.4375 2.0625C9.4375 1.6481 9.60212 1.25067 9.89515 0.957646C10.1882 0.66462 10.5856 0.5 11 0.5C11.4144 0.5 11.8118 0.66462 12.1049 0.957646C12.3979 1.25067 12.5625 1.6481 12.5625 2.0625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.cc9002a9.svg";
export { ForwardRef as ReactComponent };